import React from 'react'
import bandMarshChair from '../images/NP/FullSizeRender_2.jpg'

import { Link } from 'react-router-dom'
import Slider from '../components/Slider'
import { Helmet } from 'react-helmet-async'

const Press = () => {
  return (
    <>
      <Helmet>
        <title>The Non-Prophets - Press Kit</title>
        <meta name="description" content="Check out the press kit." />
        <link rel="canonical" href="/press" />
        <link
          rel="icon"
          type="image/png"
          href="/favicon-96x96.png"
          sizes="96x96"
        />
        <link rel="icon" type="image/svg+xml" href="favicon.svg" />
        <link rel="shortcut icon" href="favicon.ico" />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="apple-touch-icon.png"
        />
        <link rel="manifest" href="site.webmanifest" />
        <meta charset="utf-8" />
        <link
          rel="icon"
          type="image/png"
          href="favicon.ico/favicon-96x96.png"
          sizes="96x96"
        />
        <link rel="icon" type="image/svg+xml" href="favicon.ico/favicon.svg" />
        <link rel="shortcut icon" href="favicon.ico/favicon.ico" />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="favicon.ico/apple-touch-icon.png"
        />
        <meta name="apple-mobile-web-app-title" content="AMB" />
        <link rel="manifest" href="favicon.ico/site.webmanifest" />
      </Helmet>
      <div className="bg-slate-50 pt-20 md:pt-0">
        <header className="h-[35vh] overflow-hidden">
          <div className="relative h-full">
            <img
              src={bandMarshChair}
              alt="Jackson holding guitar"
              className="w-full h-[35vh] md:h-[60vh] object-cover object-[50%_10%] opacity-50"
            />
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <h1 className="text-gray-800 text-2xl md:text-3xl tracking-widest">
                Press Kit
              </h1>
            </div>
          </div>
        </header>

        <div className="border rounded-lg shadow-xl p-6 max-w-3xl mx-auto mt-6 mb-5    bg-slate-100 custom-container">
          <Slider />
        </div>
        <div className="text-center p-4">
          <Link
            target="_blank"
            to="https://drive.google.com/drive/folders/1QJyjTCF9Leu3gxsc6OQxkZ-t3DLVloJb"
          >
            <button className="rounded bg-indigo-700 text-gray-100 font-bold  py-2 px-4 tracking-widest  hover:opacity-80 duration-500 shadow-xl mr-6 ">
              DOWNLOAD HI-RES PHOTOS
            </button>
          </Link>
          <Link
            target="_blank"
            to="https://drive.google.com/drive/folders/1QJyjTCF9Leu3gxsc6OQxkZ-t3DLVloJb"
          >
            <button className="rounded bg-slate-200 text-indigo-700 font-bold mr-4 py-2 px-4 tracking-widest hover:opacity-70 duration-500 mb-6 shadow-xl mt-3 ">
              DOWNLOAD STAGE PLOT
            </button>
          </Link>
        </div>

        <div className="flex  justify-center p-6 -mt-5">
          <p className="max-w-3xl">
            The Non-Prophets are Don Story, Billy Gee, Mel Jones & Randy
            Gambill, four veteran musicians based in the foothills of North
            Carolina's Blue Ridge Mountains. Our repertoire is a dazzling
            Americana mix of covers and our own original material. Individually
            throughout our careers, we have shared the stage and/or studio with
            Bo Diddley, Doc Watson, Jim Lauderdale, Charlie Waller, Joe South,
            The Guess Who, Steppenwolf, Wet Willie, The Temptations, John Cowan,
            The James Gang, Alison Krauss, Tim O’Brien, Mark O’Connor and Darren
            & Brooke Aldrige, to name a few. With backgrounds in rock, soul,
            bluegrass, country, and R&B our motto is, “We have all travelled
            long, wayward roads to arrive at the same place.” <br></br>
            <br></br>Members of The Non-Prophets have played at a long list of
            festivals and venues including The Grand Ole Opry, Walnut Valley
            Festival (Winfield, Kansas) and at every Merlefest since its
            inception. Member's songs have been featured on BBC (British
            Broadcasting Company) Radio, NPR Radio affiliates and PBS-TV Song of
            the Mountains.
          </p>
        </div>
        <div className="text-center p-4">
          {/* <Link to="https://ashevillemountainboys.bandcamp.com/track/another-day">
            <button className="rounded bg-slate-50 text-yellow-600 font-bold  py-2 px-4 tracking-widest  hover:opacity-80 duration-500 shadow-xl mr-6 ">
              STREAM <span className="font-normal">//</span> PURCHASE
            </button>
          </Link> */}
          <Link to="/contact">
            <button className="rounded  bg-indigo-700 text-gray-100  font-bold mr-4 py-2 px-4 tracking-widest hover:opacity-70 duration-500 mb-6 shadow-xl ">
              CONTACT
            </button>
          </Link>
        </div>
      </div>
    </>
  )
}

export default Press
